import { render, staticRenderFns } from "./yingxiang-list.vue?vue&type=template&id=324633d0&scoped=true&"
import script from "./yingxiang-list.vue?vue&type=script&lang=ts&"
export * from "./yingxiang-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324633d0",
  null
  
)

export default component.exports